export function getDotColor(day) {
    if (day.alert)
        return 'bg-danger-strong';
    if (day.warning)
        return 'bg-warning';
    const isHighlighted = day.highlight === 'finish' || day.highlight === 'startAndFinish';
    return isHighlighted ? 'bg-success-medium' : 'bg-success';
}
